import { useContext } from 'react';
import Button from '../../../../components/Button';
import CancelButton from '../../../../components/CancelButton';
import InputField from '../../../../components/InputField';
import LanguageField from '../../../../components/LanguageField';
import LocaleField from '../../../../components/LocaleField';
import { CountryCodeField, PhoneInputField } from '../../../../components/PhoneInputField';
import TimezoneField from '../../../../components/TimezoneField';
import GeneralEditContext from './GeneralEditContext';
import { mobileCSS, mobilePhoneNumberFieldCSS } from './generalEditCSS';

const GeneralEditMobile = () => {
    const {
        firstName,
        onFirstNameChange,
        onLastNameChange,
        lastName,
        phone,
        phoneDisabled,
        phoneError,
        onPhoneChange,
        countryCode,
        countryCodeError,
        countries,
        onCountryCodeChange,
        onLanguageChange,
        onLocaleChange,
        onTimezoneChange,
        language,
        locale,
        timezone,
        options,
        onSave,
        onCancel,
        saveButtonDisabled,
        fieldLabels: {
            cancelLabel,
            countryCodeLabel,
            firstNameLabel,
            lastNameLabel,
            languageLabel,
            localeLabel,
            mobilePhoneLabel,
            saveLabel,
            timezoneLabel,
        },
    } = useContext(GeneralEditContext);

    const { languages, locales, timezones } = options;

    return (
        <div css={mobileCSS}>
            <InputField
                label={`${firstNameLabel}*`}
                value={firstName}
                onChange={onFirstNameChange}
            />
            <InputField label={`${lastNameLabel}*`} value={lastName} onChange={onLastNameChange} />
            <div css={mobilePhoneNumberFieldCSS}>
                <CountryCodeField
                    countries={countries}
                    label={countryCodeLabel}
                    value={countryCode}
                    onChange={onCountryCodeChange}
                    errorMessage={countryCodeError}
                />
                <PhoneInputField
                    label={mobilePhoneLabel}
                    value={phone}
                    onChange={onPhoneChange}
                    errorMessage={phoneError}
                    disabled={phoneDisabled}
                />
            </div>
            <LanguageField
                label={languageLabel}
                languages={languages}
                onChange={onLanguageChange}
                value={language}
            />
            <LocaleField
                label={localeLabel}
                locales={locales}
                onChange={onLocaleChange}
                value={locale}
            />
            <TimezoneField
                label={timezoneLabel}
                onChange={onTimezoneChange}
                value={timezone}
                timezones={timezones}
            />
            <Button onClick={onSave} disabled={saveButtonDisabled}>
                {saveLabel}
            </Button>
            <CancelButton label={cancelLabel} onClick={onCancel} />
        </div>
    );
};

export default GeneralEditMobile;
